import { render, staticRenderFns } from "./MilkVatInfoLine.vue?vue&type=template&id=0b49295c&"
import script from "./MilkVatInfoLine.vue?vue&type=script&lang=ts&"
export * from "./MilkVatInfoLine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports